import React from 'react'
import _ from 'lodash'

const ticketList = (ticket) => ticket && Object.entries(ticket).map(([key, value]) => {
  if(value){
    const display = _.capitalize(key.replace(/_/g, ' '))
    return (
    <div>
          <p style={ {marginBottom: '10px'}}>
            {display}:&nbsp;&nbsp; 
            <span style={{fontSize: '15px', fontWeight: '600'}}>{value}</span></p>
    </div>
  )}
})

const FreskDesk = ({ ticketId, ticket }) => {
  const ticketUrl = `https://photoandgo.freshdesk.com/helpdesk/tickets/${ticketId}`
  return (
    <div>
      <h2>Freshdesk <a href={ticketUrl} target="_blank">Ticket Link</a></h2>
      <div style={{ paddingLeft: '15px', paddingBottom: '20px', paddingRight: '15px' }} className="list-group">
        {ticketList(ticket)}
      </div>
    </div>
  )
}

export default FreskDesk


// WEBPACK FOOTER //
// ./src/components/orders/Common/FreshDesk.js